import { render, staticRenderFns } from "./BaseSelectV2.vue?vue&type=template&id=ccbc40f6&scoped=true&"
import script from "./BaseSelectV2.vue?vue&type=script&lang=js&"
export * from "./BaseSelectV2.vue?vue&type=script&lang=js&"
import style0 from "./BaseSelectV2.vue?vue&type=style&index=0&id=ccbc40f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbc40f6",
  null
  
)

export default component.exports